import React, { useMemo } from 'react';
import { mapNoTip } from '../../../services/FundedTips';
import PropTypes from 'prop-types';
import { Theme } from '../../layout/Theme';
import './OrderPickupMarker.scss';

function OrderPickupMarkerBase({ displayId, order }) {
  const label = useMemo(
    () => (displayId || '').slice(0, 6),
    [displayId]
  );

  const noTip = mapNoTip(order);
  const description = noTip ? `${displayId}. No Tip` : displayId;
  return (
    <div className="order-pickup-marker-container" title={description} aria-label={description}>
      <div className="marker">{label}</div>
      {noTip && <div style={{ background: '#fff3cd', color: '#795500', fontSize: 10, padding: '1px 4px', whiteSpace: 'nowrap' }}>No Tip</div>}
    </div>
  );
}

OrderPickupMarkerBase.propTypes = {
  order: PropTypes.object,
  displayId: PropTypes.string,
};

OrderPickupMarkerBase.defaultProps = {
  displayId: '',
};

export function OrderPickupMarker({ displayId, order }) {
  return (
    <Theme>
      <OrderPickupMarkerBase displayId={displayId} order={order} />
    </Theme>
  );
}

OrderPickupMarker.propTypes = {
  order: PropTypes.object,
  displayId: PropTypes.string,
};

OrderPickupMarker.defaultProps = {
  displayId: '',
};
